import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import projectsData from '../data/projects.json';

const ProjectDetailsPage = () => {
  const { projectId } = useParams();
  
  const project = projectsData.find(p => p.id === projectId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!project) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-emerald-50">
        <h1 className="text-3xl font-bold text-emerald-800 mb-4">Project Not Found</h1>
        <Link to="/project" className="px-6 py-3 bg-emerald-600 text-white rounded-full hover:bg-emerald-700 transition">
          Back to Projects
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-emerald-50 min-h-screen pb-20">

      {/* Hero Section */}
      <div className="relative w-full h-[60vh] md:h-[70vh]">
        <img 
          src={project.image} 
          alt={project.title} 
          className="w-full h-full object-cover brightness-90"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/60 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full p-6 md:p-12 lg:p-20 text-white">
            <Link to="/project" className="text-white/80 hover:text-white mb-4 inline-block text-sm font-bold tracking-wide uppercase transition-colors">
                ← Back to Projects
            </Link>
            <h1 className="text-4xl md:text-6xl font-black mb-2">{project.title}</h1>
            <p className="text-xl font-medium text-emerald-300">{project.location}</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 -mt-16 relative z-10 space-y-16">

        {/* About Section */}
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100">
          <h2 className="text-3xl font-bold text-emerald-800 mb-6 border-b pb-3">Über dieses Projekt</h2>
          <p className="text-emerald-700 text-lg leading-relaxed">{project.description}</p>
        </div>

        {/* Gallery Section */}
        {project.gallery && project.gallery.length > 0 && (
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-gray-100">
            <h2 className="text-3xl font-bold text-emerald-800 mb-6 border-b pb-3">Galerie</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {project.gallery.map((img, idx) => (
                <div key={idx} className="overflow-hidden rounded-2xl shadow-md group">
                  <img 
                    src={img} 
                    alt={`Gallery ${idx}`} 
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" 
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Cozy Info Section */}
        <div className="bg-emerald-100 rounded-3xl shadow-lg p-8 md:p-12 border border-emerald-200">
          <h2 className="text-3xl font-bold text-emerald-900 mb-6 border-b pb-3">Projektinfos</h2>
          <div className="space-y-4 text-emerald-800 text-lg">
            <p><strong>Ort:</strong> {project.location}</p>
            <p><strong>Jahr:</strong> {project.year}</p>
            <p><strong>Leistungen:</strong> {project.services ? project.services.join(", ") : "Keine Angaben"}</p>
            <p><strong>Beschreibung:</strong> Dieses Projekt wurde sorgfältig geplant und umgesetzt, um alle Anforderungen und Wünsche des Kunden zu erfüllen. Wir legen Wert auf Details, Qualität und eine nachhaltige Gestaltung, sodass der Außenbereich nicht nur schön, sondern auch funktional ist.</p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <Link 
            to="/contact" 
            className="inline-block bg-emerald-700 text-white px-8 py-4 rounded-2xl font-bold shadow-lg hover:bg-emerald-800 transition-colors"
          >
            Projekt Anfragen
          </Link>
        </div>

      </div>
    </div>
  );
};

export default ProjectDetailsPage;
